export const TEXT = {
    UPLOAD_CONFIRMATION_DIALOG_HEADER: 'Uploaded. Just like that.',
    UPLOAD_CONFIRMATION_DIALOG_DESCRIPTION: 'Your moments. Our story. Beautiful.',
    EMPTY_STATE_HEADER: 'Nothing uploaded yet',
    EMPTY_STATE_DESCRIPTION: 'Head back to select some photos or videos to share.',
    SIGNUP_BUTTON_TEXT: 'Signup to see full collection',
    GO_BACK_BUTTON_TEXT: 'go back'
}